import { UPCOMING_COLLECTION_TYPENAME } from "@/graphql/upcoming-collection/typename";

export const queries = {
  upcomingCollection: {
    read(_, { toReference, args }) {
      return toReference({
        __typename: UPCOMING_COLLECTION_TYPENAME,
        id: args.id,
      });
    }
  }
};
